import React from "react";
import { ReactComponent as RightQuoteIcon } from "./icons/quote-right.svg";
import * as Colors from "../Colors";

function QuoteLeft(props) {
  return (
    <div className="Quote-container">
      <div className="RightQuote">
        <RightQuoteIcon fill={Colors.ORANGE} />
      </div>
      <div>
        <div className="Quote-text"> {props.children}</div>
        {props.author && (
          <div className="Quote-author">{"- " + props.author}</div>
        )}
      </div>
    </div>
  );
}

export default QuoteLeft;
